import { ReactElement } from 'react';

import { EmptyStatePlaceholder, FilterPanel, Link } from '@dreryk/react-components';

import { translationKeys } from './translations';

type WaitlistEmptyStatePlaceholderProps = {
   onAddPatientToTheWaitlistClick: VoidFunction;
   patientSearchTextEntered: boolean;
};

export const WaitlistEmptyStatePlaceholder = (props: WaitlistEmptyStatePlaceholderProps): ReactElement => {
   const filtersParamsApplied = FilterPanel.useDetectParamsApplied();
   const shouldDisplayNoMatchingResults = filtersParamsApplied || props.patientSearchTextEntered;
   return (
      <EmptyStatePlaceholder
         testId={'noWaitlistEntries'}
         heading={
            shouldDisplayNoMatchingResults ? translationKeys.noMatchingResults : translationKeys.noPatientsOnTheWaitlist
         }
         subheading={shouldDisplayNoMatchingResults ? undefined : translationKeys.noAddedPatientsToTheWaitlist}
      >
         {shouldDisplayNoMatchingResults ? null : (
            <Link
               testId={'addPatientToTheWaitlist'}
               label={translationKeys.addPatientToTheWaitlist}
               onClick={props.onAddPatientToTheWaitlistClick}
            />
         )}
      </EmptyStatePlaceholder>
   );
};
